import { render, staticRenderFns } from "./CollectionAccordion.vue?vue&type=template&id=348b2902&scoped=true&lang=pug&"
import script from "./CollectionAccordion.vue?vue&type=script&lang=js&"
export * from "./CollectionAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAccordion.vue?vue&type=style&index=0&id=348b2902&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b2902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348b2902')) {
      api.createRecord('348b2902', component.options)
    } else {
      api.reload('348b2902', component.options)
    }
    module.hot.accept("./CollectionAccordion.vue?vue&type=template&id=348b2902&scoped=true&lang=pug&", function () {
      api.rerender('348b2902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionAccordion.vue"
export default component.exports